import { registerMixin, answerMixin } from 'dygc'
import SingleChoice from './choice/SingleChoice'
import MultipleChoice from './choice/MultipleChoice'
import Cascader from './cascader/Cascader'
import MatrixSingleChoice from './matrix/MatrixSingleChoice'
import MatrixMultipleChoice from './matrix/MatrixMultipleChoice'
import SingleSelectChoice from './choice/SingleSelectChoice'
import MultipleSelectChoice from './choice/MultipleSelectChoice'
import MatrixSelectChoice from './matrix/MatrixSelectChoice'
import Blanks from './text-fill/Blanks'
import TextFill from './text-fill/TextFill'
import Scale from './scale/Scale'
import MatrixCompose from './matrix/MatrixCompose'
import MatrixAuto from './matrix/MatrixAuto'
import MatrixGravity from './matrix/MatrixGravity'
import MatrixScroll from './matrix/MatrixScroll'
import MultipleBlanks from './text-fill/MultipleBlanks'
import SingleImageChoice from './choice/SingleImageChoice'
import MultipleImageChoice from './choice/MultipleImageChoice'
import MatrixFill from './matrix/MatrixFill'
import UploadFile from './specific-format/UploadFile'
import DateQ from './specific-format/DateQ'
import ImageChoice from './choice/ImageChoice'
import Classification from './choice/Classification'
import NPSScale from '@/questions/scale/NPSScale'
import MatrixScale from '@/questions/scale/MatrixScale'
import Sort from '@/questions/choice/Sort'
import HandWriting from './specific-format/HandWriting'
import SelectCascader from '@/questions/cascader/SelectCascader'
import CascadeRegion from './specific-format/CascadeRegion'
import Downloadable from './specific-format/Downloadable'
import MaxDiff from './specific-format/MaxDiff'
import MapQ from './specific-format/MapQ'
import CustomSingleScale from './scale/CustomSingleScale'
import Total from './scale/Total'
const components = {
  SingleChoice,
  MultipleChoice,
  Cascader,
  MatrixSingleChoice,
  MatrixMultipleChoice,
  SingleSelectChoice,
  MultipleSelectChoice,
  MatrixSelectChoice,
  Blanks,
  TextFill,
  Scale,
  CustomSingleScale,
  MatrixScroll,
  MatrixCompose,
  MatrixGravity,
  MatrixAuto,
  MultipleBlanks,
  SingleImageChoice,
  MultipleImageChoice,
  MatrixFill,
  UploadFile,
  DateQ,
  Classification,
  ImageChoice,
  NPSScale,
  MatrixScale,
  Sort,
  HandWriting,
  CityAddress: SelectCascader,
  CascadeRegion,
  Downloadable,
  MapQ,
  Total,
  MaxDiff
}

registerMixin(components, answerMixin)

export { components }
